import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const filterDropdownDefaultVariants = {}
const filterDropdownCompoundVariants = []

const filterDropdownSlotNames = [
  [
    "header",
    "FilterDropdown__header"
  ],
  [
    "heading",
    "FilterDropdown__heading"
  ],
  [
    "footer",
    "FilterDropdown__footer"
  ],
  [
    "checkbox",
    "FilterDropdown__checkbox"
  ],
  [
    "item",
    "FilterDropdown__item"
  ],
  [
    "helpText",
    "FilterDropdown__helpText"
  ]
]
const filterDropdownSlotFns = /* @__PURE__ */ filterDropdownSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, filterDropdownDefaultVariants, getSlotCompoundVariant(filterDropdownCompoundVariants, slotName))])

const filterDropdownFn = memo((props = {}) => {
  return Object.fromEntries(filterDropdownSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const filterDropdownVariantKeys = []
const getVariantProps = (variants) => ({ ...filterDropdownDefaultVariants, ...compact(variants) })

export const filterDropdown = /* @__PURE__ */ Object.assign(filterDropdownFn, {
  __recipe__: false,
  __name__: 'filterDropdown',
  raw: (props) => props,
  variantKeys: filterDropdownVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, filterDropdownVariantKeys)
  },
  getVariantProps
})